<template>
  <div :class="['activate-table-expandable-component text-right', stylingClasses]">
    <div> {{ value }} </div>
    <div :class="['expandable-content-wrapper', {'h-0 opacity-0': !expanded}, {'pt-5 expanded': (expanded && extraItems.length)}]">
      <div
        v-for="(extraItem, index) in extraItems"
        :id="`expandable-content-${index}`"
        :class="{
          'license block font-roboto-mono whitespace-normal': true,
          'py-2': expanded,
          'text-xs text-left': extraItem.name,
          'license-name': !!extraItem.name
        }">
        {{ extraItem.name ?? extraItem.code }}
      </div>
    </div>
  </div>
</template>

<script src="./table-column-expandable.js"></script>
<style scoped lang="scss">
@reference '#tailwind.scss';
.activate-table-expandable-component {
  .license {
    @media (max-width: 1400px) {
      @apply text-xs!;
    }
  }
  .license-name {
    @media (max-width: 1400px) {
      @apply text-[10px]!;
    }
  }
}
</style>
